<template>
<el-main class="contractno-container" ref="contractno-container">
    <div class="contractno-content">
        <div class="handle-box">
            <div class="handle-left">
                <el-button type="primary" @click="$refs.editForm.showDrawer('','add')">添加</el-button>
                <el-select class="ml8" v-model="query.company_id" clearable filterable placeholder="选择公司">
                    <el-option v-for="item in companyList" :key="item.id" :label="item.title" :value="item.id + ''"></el-option>
                </el-select>
                <el-input class="search-input ml8" v-model="query.collection_code" placeholder="收款编号" clearable></el-input>
                <el-button type="primary" @click="doSearch">查询</el-button>
                <el-button type="primary" @click="download">导出</el-button>
            </div>
        </div>
        <div class="table-box">
            <el-table :data="tableData" ref="tableData" v-loading="loading" :height="tableHeight" :max-height="tableHeight" @sort-change="sortChange">
                <el-table-column prop="id" label="编号"> </el-table-column>
                <el-table-column prop="company.title" label="归属公司"> </el-table-column>
                <el-table-column prop="collection_code" label="收款编号"> </el-table-column>
                <el-table-column prop="is_used_tag" label="是否使用" sortable align="center"> </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button-group>
                            <el-button @click="$refs.editForm.showDrawer(scope.row,'edit')" type="primary" size="mini">编辑</el-button>
                            <el-button @click="deleteFn(scope.$index, scope.row)" type="danger" size="mini">删除</el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="footer-box">
            <div class="download"></div>
            <div class="pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.page" :page-sizes="[14, 20, 30, 50]" :page-size="pagination.limit" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
                </el-pagination>
            </div>
        </div>
    </div>

    <editForm ref="editForm" @getTableData="getTableData" @showLog="showLog"></editForm>
    <batchLogDialog ref="batchLogDialog"></batchLogDialog>
</el-main>
</template>

<script>
import dictionary from '@/utils/dictionary';

import editForm from './edit';
import batchLogDialog from './log';
const query = {
    company_id: '',
    collection_code: ''
}
export default {
    components: {
        editForm,
        batchLogDialog
    },
    data() {
        let windowheight = window.innerHeight;
        return {
            query: Object.assign({}, query),
            loading: false,
            tableData: [],
            tableHeight: windowheight,
            pagination: {
                page: 1,
                limit: 14,
                total: 0
            }
        };
    },
    created() {
        this.getTableData();
    },
    beforeMount() {
        this.dictionary = dictionary;
    },
    mounted() {
        this.$nextTick(() => {
            this.tableHeight = window.innerHeight - 224;
        });
    },
    computed: {
        companyList: function () {
            return dictionary.getPicker('company');
        },

    },
    methods: {
        getTableData() {
            //获取表格列表
            let that = this;
            let url = '/api/order.collection_code/index';
            let query = this.query;
            query.pagination = this.pagination;
            this.loading = true;
            this.$post(url, query).then(function (response) {
                let result = response.data;
                that.tableData = result.list;
                that.pagination = result.pagination;
                that.loading = false;
            });
        },
        doSearch() {
            // 搜索
            this.pagination.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData();
        },
        // 排序
        sortChange(e) {
            if (e.order) {
                let sort = {};
                sort.field = e.prop;
                sort.order = e.order == 'descending' ? 'desc' : 'asc';
                this.sort = sort;
            } else {
                this.sort = {};
            }
            this.getTableData();
        },
        deleteFn(index, e) {
            let _this = this;
            this.$confirm('此操作将, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                .then(() => {
                    let url = '/api/order.collection_code/delete';
                    let query = {
                        id: e.id
                    };
                    this.loading = true;
                    this.$post(url, query).then(function (response) {
                        if (response.code == 200) {
                            _this.getTableData();
                            _this.$message.success(response.msg);
                            _this.loading = false;
                        } else {
                            _this.$message.error(response.msg);
                            _this.loading = false;
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
        },
        showLog(batchNo) {
            this.$refs['batchLogDialog'].getTableData(batchNo);
        },
        download() {
            let _this = this;
            let url = '/api/order.collection_code/download';
            let options = _this.query;
            this.$post(url, options).then((res) => {
                if (res.code == '200') {
                    let link = document.createElement('a');
                    link.href = res.data.url;
                    link.click();
                }
            });
        }
    }
};
</script>

<style lang="less">
@import url('@/assets/css/common.less');
</style>
